/**
 * Defines the provisional allowlist exposed before private evidence storage is implemented.
 */
import { z } from "zod";
function IsSafeEvidenceFileName(value) {
    if (value.includes("/") || value.includes("\\")) {
        return false;
    }
    for (let index = 0; index < value.length; index += 1) {
        const codeUnit = value.charCodeAt(index);
        if (codeUnit < 32 || codeUnit === 127) {
            return false;
        }
    }
    return true;
}
export const EvidenceMediaTypeSchema = z.enum([
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/webp",
]);
export const EvidenceFormatCheckRequestSchema = z
    .object({
    fileName: z.string().trim().min(1).max(255).refine(IsSafeEvidenceFileName),
    mediaType: EvidenceMediaTypeSchema,
})
    .strict();
export const EvidenceFormatSchema = z
    .object({
    extensions: z.array(z.string().regex(/^\.[a-z0-9]+$/)).min(1),
    mediaType: EvidenceMediaTypeSchema,
})
    .strict();
export const EvidencePolicyResponseSchema = z
    .object({
    allowedFormats: z.array(EvidenceFormatSchema).min(1),
    antimalwareStatus: z.literal("DISABLED_BY_PRODUCT_DECISION"),
    contentVerification: z.literal("REQUIRED_BEFORE_AVAILABILITY"),
    policyVersion: z.literal("2026-07-29.1-PROVISIONAL"),
})
    .strict();
export const EvidenceFormatCheckResponseSchema = z
    .object({
    accepted: z.literal(true),
    extension: z.string().regex(/^\.[a-z0-9]+$/),
    mediaType: EvidenceMediaTypeSchema,
    policyVersion: z.literal("2026-07-29.1-PROVISIONAL"),
})
    .strict();
//# sourceMappingURL=EvidenceContract.js.map